import ReactDOM from "react-dom";
import { X } from "lucide-react";
import { Main } from "./style";
import { Node, useNodes } from "reactflow";
import { operationType } from "../../services/types";
import { AIChatInterface } from "../run/agentChat";

export interface settingsDataType { isToggle: boolean }
const Portal = ({ children }: { children: React.ReactNode }) => ReactDOM.createPortal(children, document.body);

export function SettingsBlock(
   { nodeId, data, setData, children }:
      { nodeId: string, data: settingsDataType, setData: React.Dispatch<React.SetStateAction<settingsDataType>>, children?: React.ReactNode }
) {
   const nodes: Node<operationType>[] = useNodes();
   const currentNode = nodes.find(node => node.id === nodeId);
   const isAiAgentNode = currentNode?.data.action === 'aiAgent';

   const panelClassName = [
      data.isToggle ? 'show' : '',
      isAiAgentNode ? 'ai-agent' : '',
   ].filter(Boolean).join(' ');

   return (
      <Portal>
         <Main className={panelClassName}>
            <X className="close" onClick={_ => setData(prev => ({ ...prev, isToggle: false }))} />
            <div className="scroll">
               { isAiAgentNode ? (
                  <AIChatInterface nodeId={nodeId} currentNode={currentNode} />
               ) : children ? (
                  children
               ) : (
                  <div className="empty">No settings available</div>
               )}
            </div>
         </Main>
      </Portal>
   );
}